<section class="sectionGap faq" id="faq">
  <div class="container">
    <h2 class="section-title mx-auto text-center">
      {{ 'faq.title' | translate }}
    </h2>

    <p class="section-desc font-16 font-sm-24 text-center mx-auto mb-5">
      {{ 'faq.desc' | translate }}
    </p>
    <!-- <h2 class="font-40 fw-bold section-title d-block d-lg-none">{{ 'faq.mob_head' | translate }}</h2> -->

    <div class="row d-flex align-items-center justify-content-center">
      <div class="col-12">
        <div class="faq-wrapper pt-4">
          <accordion [closeOthers]="true" [isAnimated]="true">
            <accordion-group *ngFor="let item of faqItems; let i = index">
              <div class="position-relative w-100 d-flex justify-content-between" accordion-heading>
                <span class="font-14 font-sm-18">
                  {{ item.heading | translate }}
                </span>
                <img src="/assets/images/svg-icons/angle-down-arrow.svg" loading="lazy" class="icon" alt="arrow"
                  height="19" />
              </div>
              <div accordion-panel class="mt-0">
                <div class="para">
                  <span class=" fw-regular " [innerHTML]="item.content | translate"></span>
                  <p class="para-sub text-start text-white fw-regular mb-0" *ngIf="item.content_2"
                    [innerHTML]="item.content_2 | translate"></p>
                  <ul *ngIf="item.list?.length" class="faq-list text-start text-white ms-3 "
                    [class.mt-3]="!item.content_2">
                    <li *ngFor="let list of item.list" [innerHTML]="list | translate"></li>
                  </ul>
                  <p class="para-sub text-start text-white fw-regular mb-0" *ngIf="item.content_3"
                    [innerHTML]="item.content_3 | translate"></p>
                  <p class="para-sub text-start text-white fw-regular mb-0" *ngIf="item.content_4"
                    [innerHTML]="item.content_4 | translate"></p>
                </div>
              </div>
            </accordion-group>
          </accordion>
        </div>
      </div>
    </div>

    <div class="my-3 my-sm-5">
      <div class="cta-card">
        <div class="text-center p-4 p-md-5">
          <h4 class="mb-3 text-white">{{ "faq.still_have_questions" | translate }}</h4>
          <p class="mb-4 fw-normal join-desc">{{ "faq.join_community" | translate }}</p>
          <div class="d-flex justify-content-center gap-3 flex-wrap mt-4 pt-3">
            <a href="https://t.me/QXMPLabs" target="_blank" title="Join our Telegram community"
              class="btn btn-secondary">{{
              "faq.join_telegram" | translate }}</a>
            <!-- <button class="btn btn-secondary">{{ "faq.join_discord" | translate }}</button> -->
            <a href="mailto:hello@qxmp.ai" target="_blank" title="Contact us via email" class="btn btn-primary">{{
              "faq.contact" | translate }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>